export type SavedRoutesVariant = 'regular' | 'modal';

export enum WorkflowTravelTimeToolbarTab {
  SavedRoutes = 'saved_routes',
  Locations = 'locations',
}
